import { render, staticRenderFns } from "./ReviseCertificate.vue?vue&type=template&id=b46851b0&scoped=true&"
import script from "./ReviseCertificate.vue?vue&type=script&lang=js&"
export * from "./ReviseCertificate.vue?vue&type=script&lang=js&"
import style0 from "./ReviseCertificate.vue?vue&type=style&index=0&id=b46851b0&prod&scoped=true&lang=css&"
import style1 from "./ReviseCertificate.vue?vue&type=style&index=1&id=b46851b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b46851b0",
  null
  
)

export default component.exports